var map = {
	"./en.json": 13341,
	"./en/confirm-reservation.json": 43917,
	"./en/contracts.json": 45909,
	"./en/errors.json": 32401,
	"./en/message.json": 6965,
	"./en/notifications.json": 17234,
	"./en/prices.json": 19112,
	"./en/subscriptions.json": 49564,
	"./ru.json": 23991,
	"./ru/confirm-reservation.json": 59335,
	"./ru/contracts.json": 28971,
	"./ru/errors.json": 73207,
	"./ru/message.json": 45303,
	"./ru/notifications.json": 15788,
	"./ru/prices.json": 87318,
	"lang/en.json": 13341,
	"lang/en/confirm-reservation.json": 43917,
	"lang/en/contracts.json": 45909,
	"lang/en/errors.json": 32401,
	"lang/en/message.json": 6965,
	"lang/en/notifications.json": 17234,
	"lang/en/prices.json": 19112,
	"lang/en/subscriptions.json": 49564,
	"lang/ru.json": 23991,
	"lang/ru/confirm-reservation.json": 59335,
	"lang/ru/contracts.json": 28971,
	"lang/ru/errors.json": 73207,
	"lang/ru/message.json": 45303,
	"lang/ru/notifications.json": 15788,
	"lang/ru/prices.json": 87318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55781;